import React, { useMemo } from 'react';
import './Footer.css';
import whiteLogo from '../assets/logo/logo-white.png';
import { Link, useLocation } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import Button from './common/Button';

interface FooterProps {
  ctaText?: {
    prefix?: string;
    highlight1?: string;
    middle?: string;
    highlight2?: string;
    suffix?: string;
  };
  buttonText?: string;
  buttonLink?: string;
}

const getContactUrl = (pathname: string): string => {
  const defaultContactUrl = '/contact';
  
   const contactMapping: Record<string, string> = {
    '/individuals': '/contact?type=individual',
    '/individuals-pricing': '/contact?type=individual',
    '/business': '/contact?type=company',
    '/industries': '/contact?type=company',
    '/partner': '/contact?type=company',
  };
  
  return contactMapping[pathname] || defaultContactUrl;
};

const Footer: React.FC<FooterProps> = ({
  ctaText = {
    prefix: '',
    highlight1: 'Get started',
    middle: ' today and take control of your finances with ',
    highlight2: 'EPAYR',
    suffix: ''
  },
  buttonText = 'Contact us',
  buttonLink = '#contact'
}) => {
  const location = useLocation();
  
  const contactUrl = useMemo(() => {
    return getContactUrl(location.pathname);
  }, [location.pathname]);

  const footerItems = [
    { text: 'CONTACT US', href: contactUrl},
    { text: 'CODE OF CONDUCT', href: '/code-of-conduct' },
    { text: 'PRIVACY POLICY', href: '/privacy-policy' },
    { text: 'COOKIE POLICY', href: '/cookie-policy' },
    // { text: 'TERMS OF USE', href: '/terms' },
  ];

  return (
    <Box sx={{
      display: "flex",
      maxWidth: "1416px",
      width: "100%",
      margin: "0 auto",
      padding: {md: "50px 40px 20px 40px", xs: "40px 20px 24px 20px"},
      flexDirection: "column",
      alignItems: {md: "center", xs: "flex-start"},
      gap: {md: "80px", xs: "56px"},
      borderRadius: "12px",
      backgroundColor: "darkPurple.500",
    }}>
      <Box component="nav" sx={{
        display : "flex",
        justifyContent: "center",
        alignItems: {md: "center", xs: "flex-start"},
        gap: {md: "20px", xs: "16px"},
        flexDirection: {md: "row", xs: "column"},
        alignSelf: "stretch",
      }}>
        {footerItems.map((item, index) => (
          <Link key={index} to={item.href} style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            textDecoration: "none",
            color: "inherit",
          }}>
            <Box component="div" sx={{
              width: "8px", 
              height: "8px",
              aspectRatio: "1",
              borderRadius: "4px",
              backgroundColor: "lime.100",
              }}/>
              <Typography variant='body7' color='beige.100'>
                {item.text}
              </Typography>
          </Link>
        ))}
      </Box>

      {buttonText && (ctaText.prefix || ctaText.highlight1) && <Box sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: {md: "center", xs: "flex-start"},
        gap: {md: "32px", xs: "24px"},
        maxWidth: "756px",
      }}>
        <Typography variant='subtitle8' sx={{color: "beige.100", textAlign: {md: "center", xs: "flex-start"}}}>
          <Box component="span" dangerouslySetInnerHTML={{ __html: ctaText.prefix || '' }}/>
          <Box component="span" sx={{color: "lightPurple.400"}} dangerouslySetInnerHTML={{ __html: ctaText.highlight1 || '' }}/>
          <Box component="span" dangerouslySetInnerHTML={{ __html: ctaText.middle || '' }}/>
          <Box component="span" sx={{color: "lightPurple.400"}}  dangerouslySetInnerHTML={{ __html: ctaText.highlight2 || '' }}/>
          <Box component="span" dangerouslySetInnerHTML={{ __html: ctaText.suffix || '' }}/>
        </Typography>

        <Button href={buttonLink}>
          {buttonText}
        </Button>
      </Box>
      }

      <div className="footer-company-info">
        <img
          src={whiteLogo}
          alt="EPAYR Logo"
          className="footer-footer-logo"
        />
        <span className="footer-copyright">2025©</span>
        <span className="footer-design-credit">designed by purrweb</span>
        <p className="footer-legal-info">
          EPAYR is operating under the legal name of EMPAYER PAYMENT SOLUTIONS LIMITED, 
          the company is registered in Canada (No. BC1472754)
        </p>
      </div>
    </Box>
  );
};

export default Footer;
